module.exports = __webpack_public_path__ + "img/Summit_01@2x.f1bd0c8b.jpg";